﻿import * as paths from '../utils/paths';

export default class GeneralSettingsHandler {
    constructor(rootURL, mapId) {
        this.rootURL = rootURL;
        this.mapId = mapId;
        this.settings = {};
        this.pendingChanges = false;
        this.initialProjection = null;
    }

    load() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: this.rootURL + paths.MAP_GENERAL_SETTINGS_URL + this.mapId,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    this.settings = result;
                    this.initialProjection = this.settings.ProjCode;
                    resolve();
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }

    setProjection(projectionCode) {
        this.settings.ProjCode = projectionCode;
        this.pendingChanges = true;
    }
}